import { Component, OnInit } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { RouterModule } from '@angular/router';
import { LandingFooterComponent } from 'src/app/creative/public/audiovisual/_shared/landing-footer/landing-footer.component';
import { BloqueFaqsComponent } from 'src/app/_shared/bloque-faqs/bloque-faqs.component';
import { Faq } from 'src/app/_shared/bloque-faqs/_models/faq';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { LandingHeaderComponent } from 'src/app/creative/public/audiovisual/_shared/landing-header/landing-header.component';

@Component({
  selector: 'app-landing-index',
  standalone: true,
  imports: [
    SharedModule, 
    RouterModule, 
    LandingHeaderComponent,
    LandingFooterComponent,
    BloqueFaqsComponent
  ],
  templateUrl: './landing-index.component.html',
  styleUrls: ['./landing-index.component.scss']
})
export class LandingIndexComponent implements OnInit {
  faqs: Faq[];
  swiperVentajas: Swiper;
  ngOnInit(): void
  {
    this.getPreguntasFrecuentes();
  }

  ngAfterViewInit(): void{
    this.buildSwiper();
  }

  private buildSwiper(): void
  {

    Swiper.use([Navigation, Pagination]);
    this.swiperVentajas = new Swiper('.swiperVentajasCreative', {
      slidesPerView: 1.2,
      spaceBetween: 10,
      breakpoints: {
        325: {
          slidesPerView: 1.1,
          spaceBetween: 20
        },
        767.98: {
          slidesPerView: 2.1,
          spaceBetween: 20
        },
        991.98: {
          slidesPerView: 3.1,
          spaceBetween: 20
        },
        1199.98: {
          slidesPerView: 4,
          spaceBetween: 25
        }
      },
      // FIX margin inicial / final de ficha cortada en mobile
      on: {
      slideChange: function ()
      {
        let isLastSlide = (this.slides.length === this.realIndex + 1) ? true : false;
        if (isLastSlide)
        {
          document.getElementById('swiper-landing-creative').className = 'col-12 ps-0';
        } else
        {
          document.getElementById('swiper-landing-creative').className = 'col-12 pe-0';
        }
      },
    },
      pagination: {
        el: '.swiper-pagination-ventajas-creative',
        clickable: true
      },
    });
  }

  private getPreguntasFrecuentes(): void
  {
    const respuestaClass: string = 'p1-regular mb-0';
    this.faqs = [
      {
        pregunta: '¿Quién puede solicitar la financiación y para qué tipo de proyectos? ',
        respuesta: `
        <p class='${respuestaClass}'>
        Esta financiación está destinada a empresas del sector audiovisual domiciliadas en España con un proyecto audiovisual en cualquier fase de desarrollo y producción.
        </p>`,
      },
      {
        pregunta: '¿Qué importe se puede solicitar? ',
        respuesta: `
        <p class='${respuestaClass}'>
        Por Ley, el importe máximo es de 5M.€ por solicitante/año.
        </p>`,
      },
      {
        pregunta: '¿Dónde y cómo puedo solicitar financiación?',
        respuesta: `
        <p class='${respuestaClass}'>
        Directamente a través de esta plataforma completando el formulario y adjuntando la documentación requerida.
        </p>`,
      }
    ];
  }
}
